'use client';

import {
  AnimatePresence,
  LazyMotion,
  domAnimation,
  m,
  useReducedMotion,
} from 'framer-motion';
import { getVoiceToolActivityCopy } from '@/i18n/voice-tool-activity-copy';
import type { VoiceToolActivity } from '@/lib/voice-tool-activity';

export function VoiceToolActivityBubble({
  activity,
  locale,
}: {
  activity: VoiceToolActivity | null;
  locale: string;
}) {
  const reducedMotion = useReducedMotion();
  const label = activity ? getVoiceToolActivityCopy(locale)[activity] : null;
  return (
    <LazyMotion features={domAnimation}>
      <span
        data-slot="voice-tool-activity-status"
        className="sr-only"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {label}
      </span>
      <AnimatePresence initial={false}>
        {label && (
          <m.div
            key="tool-activity"
            data-slot="voice-tool-activity"
            className="type-micro border-border/35 bg-card/95 text-foreground pointer-events-none absolute -top-4 -right-6 z-30 max-w-28 rounded-full border px-2 py-0.5 shadow-sm backdrop-blur-md"
            aria-hidden="true"
            title={label}
            initial={{
              opacity: 0,
              y: reducedMotion ? 0 : 3,
              scale: reducedMotion ? 1 : 0.94,
            }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{
              opacity: 0,
              y: reducedMotion ? 0 : 2,
              scale: reducedMotion ? 1 : 0.96,
            }}
            transition={{
              duration: reducedMotion ? 0 : 0.16,
              ease: [0.16, 1, 0.3, 1],
            }}
          >
            <span className="block truncate">{label}</span>
            <span
              aria-hidden="true"
              className="border-border/35 bg-card absolute -bottom-1 left-3 size-2 rounded-full border"
            />
            <span
              aria-hidden="true"
              className="border-border/35 bg-card absolute -bottom-2 left-2 size-1 rounded-full border"
            />
          </m.div>
        )}
      </AnimatePresence>
    </LazyMotion>
  );
}
